import Plyr from 'plyr';

class Video {
    constructor() {

        const players = document.querySelectorAll('.video .player');

        if(players) {
            players.forEach((player) => {
                const modal = player.closest('.hero-video-modal');

                if (modal) {
                    //do modal stuff here
                    const modalTrigger = document.querySelector('.modal-video-trigger');
                    const newPlayer = new Plyr(player, {
                      debug: false,
                      ratio: "16:9"
                    });
                    newPlayer.pause();

                    if(modalTrigger) {
                        modalTrigger.querySelector('button').addEventListener('click', (e) => {
                            modal.classList.add('open');
                            window.setTimeout(() => {
                                newPlayer.play();
                            }, 250);
                        });
                    }

                    var modalFilter = modal.querySelector(".filter");
                    if (modalFilter) {
                      modalFilter.addEventListener("click", (e) => {
                        if (modal.classList.contains("open")) {
                          modal.classList.remove("open");
                          newPlayer.stop();
                        }
                      });
                    }
                    
                    var modalClose = modal.querySelector(".close-modal");
                    if (modalClose) {
                        modalClose.addEventListener("click", (e) => {
                          if (modal.classList.contains("open")) {
                            modal.classList.remove("open");
                            newPlayer.stop();
                          }
                        });
                    }
                } else {
                    var mute = player.dataset.mute;
                    var autoplay = player.dataset.autoplay
                    const newPlayer = new Plyr(player, {
                      debug: false,
                      ratio: "16:9",
                      autoplay: autoplay == "1" ? true : false,
                      muted: mute == "1" ? true : false,
                      controls: [
                        "play-large",
                        "play",
                        "volume",
                        "fullscreen",
                        "progress",
                        "mute",
                      ],
                    });
    
                    player.querySelector('.plyr__control').addEventListener('click', (e) => {
                        newPlayer.play();
                    });
    
                    newPlayer.on('play', (event) => {
                        player.controls = [
                          "play-large",
                          "play",
                          "volume",
                          "fullscreen",
                          "progress",
                          "mute",
                        ];
                        console.log(event);
                    });
                }    
            });
        }
    }
} 

$(document).ready(function() {
    new Video;
});